import React from 'react'
import ErrorPage from '../components/Error/js/ErrorPage'

const DemoErrorPage = () => {
  return (
    <ErrorPage
        errorStatus = {403}
        errorMessage = "Access Denied"
        errorDesc = "This demo link is invalid. Please return to your résumé and open the demo from there."
        page = "demo"
    />
  )
}

export default DemoErrorPage